<!-- 特典を探す カテゴリから -->
<template>
  <section class="crly-m-common-search-category crly-m-common-search-common">
    <CrlyAtomsCommonSearchTitle :title="$t('search.category.title')" />
    <ul class="crly-m-common-search-category__list">
      <template v-for="(category, index) in categories">
        <CrlyMoleculesCommonSearchCategoryLarge
          :key="index"
          :category="category"
          :finishAnimation="finishAnimation"
          @clickLrgCat="$listeners['clickLrgCat']"
        />
      </template>
    </ul>
  </section>
</template>

<script>
import CategoryList from "@crly/assets/data/categorySeek";
import CrlyAtomsCommonSearchTitle from "@crly/components/atoms/common/search/Title.vue";
import CrlyMoleculesCommonSearchCategoryLarge from "@crly/components/molecules/common/search/category/Large.vue";

export default {
  name: "CrlyMoleculesCommonSearchCategory",
  components: {
    CrlyAtomsCommonSearchTitle,
    CrlyMoleculesCommonSearchCategoryLarge
  },
  props: {
    /**
     * 表示アニメーションが終了したか
     */
    finishAnimation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    /**
     * カテゴリの一覧をグループごとにして取得する
     */
    categories() {
      return CategoryList.getAll();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/common/search/common.scss";
@import "@crly/assets/css/molecules/common/search/category/category.scss";
</style>
